// @flow
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import InfoIcon from 'material-ui/svg-icons/action/info';

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  padding: ${({ theme }) => theme.metrics.smallMargin}px;
  padding-left: ${({ theme }) => theme.metrics.margin}px;

  color: ${({ theme, type }) => theme.colors.message[type].color};
  background-color: ${({ theme, type }) => theme.colors.message[type].background};
  font-size: 90%;

  z-index: 1000;
`;

export type MessageType =
  | 'important'
  | 'info';

type Props = {
  message: string,
  type: MessageType,

  theme: any,
}

function PageMessage({ message, type, theme }: Props) {
  return (
    <Wrapper type={type}>
      <InfoIcon style={{ color: theme.colors.message[type].color, marginRight: theme.metrics.margin }} /> {message}
    </Wrapper>
  );
}

export default withTheme(PageMessage);



// WEBPACK FOOTER //
// ./src/common/components/PageMessage.js